<template>
  <div class="onlineUserPage">
    <!-- 面包屑 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('onlineUser.txt1')}}</span>
        <span>{{$t('onlineUser.txt2')}} / {{$t('onlineUser.txt3')}}</span>
      </div>
    </div>
    <el-card class="tableCard">
      <el-table :data="dataList" :default-sort = "{prop: 'projName', order: 'descending'}">
        <el-table-column
        :label="$t('onlineUser.txt4')"
        type="index"
        width="50">
      </el-table-column>
      <el-table-column :label="$t('onlineUser.txt5')">
        <template slot-scope="scope">
          <span>{{scope.row.userName?scope.row.userName:'--'}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('onlineUser.txt6')">
        <template slot-scope="scope">
          <span>{{scope.row.realName?scope.row.realName:'--'}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('onlineUser.txt7')" >
        <template slot-scope="scope">
          <span>{{scope.row.desktopName?scope.row.desktopName:'--'}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('onlineUser.txt8')" >
        <template slot-scope="scope">
          <span>{{scope.row.lanIp?scope.row.lanIp:'--'}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('onlineUser.txt9')" >
        <template slot-scope="scope">
          <span>{{scope.row.wanIp?scope.row.wanIp:'--'}}</span>
        </template>
      </el-table-column>
      <el-table-column  :label="$t('onlineUser.txt10')">
        <template slot-scope="scope">
          <el-button @click="handleDelete(scope.row)" class="handleBtn" type="text">{{$t('onlineUser.txt11')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
  <div class="table-footer tablePagination" v-show="total>0">
    <el-pagination
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="queryInfo.currentPage"
    :page-sizes="[10, 20, 30, 40]"
    layout="total, sizes, prev, pager, next"
    :total="total">
  </el-pagination>
</div>     
</div>
</template>

<script>
  import qs from 'qs';
  export default {
    data() {
      return {
        //用于获取数据列表
        queryInfo: {
          currentPage:1,
          pageSize:10,
        },
        dataList: [],
        total: 0,
      };
    },
    created() {
      this.loadData();
    },
    methods: {
      // 在线用户列表
      async loadData() {
        const {data: res} = await this.$http.get("/idw/getOnlinUserList?"+ qs.stringify(this.queryInfo));
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.dataList = res.result.data;
        this.total = res.result.totalRow;
      },
      // 删除
      handleDelete(row){
        let id = row.id;
        this.$confirm('<p class="color666 fz14">'+this.$t('onlineUser.txt12')+'</p>', this.$t('onlineUser.txt13'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('onlineUser.txt14'),
          cancelButtonText: this.$t('onlineUser.txt15'),
          type: 'warning',
          center: true
        }).then(() => {
          this.closeDesktop(id);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('onlineUser.txt16')
          });    
        });
      },
      // 在线用户列表
      async closeDesktop(id) {
        let data = {
          userId:id
        }
        const {data: res} = await this.$http.get("/idw/closeDesktop?"+ qs.stringify(data));
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.loadData();
      },
      // 页面切换
      handleCurrentChange(pageNum) {
        this.queryInfo.currentPage = pageNum;
        this.loadData();
      },
      handleSizeChange(pageSize){
        this.queryInfo.pageSize = pageSize;
        this.loadData();
      },
    },
  };
</script>

<style lang="less" scoped>
  .onlineUserPage{
    /deep/ .el-button--primary{
      width: auto;
      height: auto;
      padding:0;
      background: none;
    }
    /deep/ .el-button--primary.is-disabled{
      background: none;
      border: none;
    }
    .tips{      
      font-size: 1.4rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #98B9FF;
      margin-top: -10px;
    }
    /deep/ .el-dialog{
      /deep/ .el-input,/deep/ .el-input__inner{
        width: 100% !important;
      }
      /deep/ .el-form-item:first-of-type,/deep/ .el-form-item:last-of-type{
        margin-bottom: 0;
      }
      /deep/ .el-dialog .el-dialog__body .el-select .el-input__inner, .el-dialog .el-dialog__body .el-input__inner, .el-dialog .el-dialog__body .el-input{
        border-radius: 8px; 
      }
    }
  }
</style>
